import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@/features/auth/AuthProvider'
import { ProtectedRoute } from '@/features/auth/ProtectedRoute'
import { AttendeesPage } from '@/routes/AttendeesPage'
import { EventLayout } from '@/routes/EventLayout'
import { EventOverviewPage } from '@/routes/EventOverviewPage'
import { EventsListPage } from '@/routes/EventsListPage'
import { FormPage } from '@/routes/FormPage'
import { LoginPage } from '@/routes/LoginPage'
import { PublicFormPage } from '@/routes/PublicFormPage'
import { ResultsPage } from '@/routes/ResultsPage'
import { SettingsPage } from '@/routes/SettingsPage'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public: no Supabase session, gated by the shared event passcode. */}
          <Route path="/f/:slug" element={<PublicFormPage />} />

          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <EventsListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/:eventId"
            element={
              <ProtectedRoute>
                <EventLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<EventOverviewPage />} />
            <Route path="attendees" element={<AttendeesPage />} />
            <Route path="form" element={<FormPage />} />
            <Route path="results" element={<ResultsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
